import React from 'react';
import { Package } from '@phosphor-icons/react';
import BottomNav from '../components/BottomNav';

const BookingsPage = () => {
  return (
    <div className="min-h-screen bg-[#E7EEEE] pb-20">
      <div className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-gray-200 p-4">
        <h1 className="text-2xl font-bold text-[#1B375B]" style={{ fontFamily: 'Outfit, sans-serif' }}>
          My Bookings
        </h1>
      </div>
      
      <div className="p-4">
        <div className="flex flex-col items-center justify-center py-20">
          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
            <Package size={40} className="text-gray-300" />
          </div>
          <p className="text-lg font-semibold text-[#1B375B] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            No bookings yet
          </p>
          <p className="text-sm text-gray-500 text-center max-w-xs" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Your flight bookings will appear here once you make a booking
          </p>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default BookingsPage;